export function getViteAppOktaIssuer(): string {
  return import.meta.env.VITE_OKTA_ISSUER;
}
